import { getLocalApiUrl, authFetch } from '../../config/api'

export const FORM_RESPONSE_STATUSES = new Set(['submitted', 'accepted', 'in_review'])

export function assignmentHasResponse(assignment) {
  if (!assignment) return false
  return !!(assignment.submittedAt || FORM_RESPONSE_STATUSES.has(assignment.status))
}

export async function fetchSubjectFormResponses({ subjectType, subjectId, patronId } = {}) {
  const qs = new URLSearchParams()
  if (subjectType) qs.set('subjectType', subjectType)
  if (subjectId) qs.set('subjectId', String(subjectId))
  if (patronId) qs.set('patronId', String(patronId))
  const res = await authFetch(getLocalApiUrl(`/api/forms/subject-responses?${qs}`))
  const j = await res.json()
  if (!res.ok || !j.success) throw new Error(j.error || 'Failed to load form responses')
  return j.data || []
}

export function fmtFormResponseWhen(v) {
  if (!v) return '—'
  try {
    return new Date(v).toLocaleString('en-AU')
  } catch {
    return String(v)
  }
}
